export default __webpack_public_path__ + "static/media/ac_sip.79159808.bmp";